import axios from "axios";

/* cate */
export const svProducCate = (language) => {
    return axios
        .get(`productcate/data?language=${language}`)
        .then((res) => res)
        .catch((err) => err);
};

export const svCreateProducCate = (formData) => {
    return axios
        .post(`productcate/create`, formData)
        .then((res) => res)
        .catch((err) => err);
};

export const svUpdateProducCate = (id, formData) => {
    return axios
        .post(`productcate/update/${id}`, formData)
        .then((res) => res)
        .catch((err) => err);
};

export const svDeleteProducCate = (id,language) =>{
    return axios
    .delete(`productcate/destroy/${id}/${language}`)
    .then((res) => res)
    .catch((err) => err);
};

export const svDeleteSegment = (id) =>{
    return axios
    .delete(`productcate/segment/destroy/${id}`)
    .then((res) => res)
    .catch((err) => err);
};

export const svcreateSegment = (title) =>{
    return axios
    .post(`productcate/segment/create`, title )
    .then((res) => res)
    .catch((err) => err);
};

export const svUpdateSegment = (id, title) =>{
    return axios.post(`productcate/segment/update/${id}`, title )
    .then((res) => res)
    .catch((err) => err);
};